define(
    ['assets/js/backbone-extended', 'assets/js/modules/design/designOptionsContext', 'assets/js/modules/product/model/attributeModel'],
    function(backboneExtended, designOptionsContext, AttributeModel) {
        return backboneExtended.NestedModel.extend({
            relations: {
                defaultOptions: designOptionsContext
            },
            defaults: {
                slug: null,
                group: null,
                bleedRatio: 1,
                shape: AttributeModel.VALUE_SHAPE_RECTANGULAR,
                isCrossSells: false,

                /**
                 * Collection of ProductSampleModel models
                 *
                 * @type {backboneExtended.Collection}
                 */
                samples: new backboneExtended.Collection()
            }
        });
    }
);
